/** Every session slot is busy and this chat's message waits in line ("2 ahead" when not next). */
export function slotWaitLabel(slotPlace: number | undefined): string {
  const ahead = typeof slotPlace === "number" && slotPlace > 1 ? Math.floor(slotPlace) - 1 : 0;
  return ahead > 0 ? `Waiting for a slot (${ahead} ahead)` : "Waiting for a slot";
}
